// src/components/AlbumsContent.jsx
import React, { useState } from 'react';
import { Music, Popcorn, Book } from 'lucide-react';
import BlogEntry from './BlogEntry';
import useBlogEntries from '../hooks/useBlogEntries.js';
import { PRIMARY_FONT } from '../constants';

const AlbumsContent = ({ activeTag, setActiveTag }) => {
  const [expandedEntry, setExpandedEntry] = useState(null);
  const blogEntries = useBlogEntries();

  const filteredEntries = activeTag === 'all'
    ? blogEntries
    : blogEntries.filter(entry => entry.tags.includes(activeTag));

  const sortedEntries = [...filteredEntries].sort((a, b) => {
    if (activeTag === 'all') {
      if (a.tags.includes('music') && !b.tags.includes('music')) return -1;
      if (!a.tags.includes('music') && b.tags.includes('music')) return 1;
    }
    return new Date(b.date) - new Date(a.date);
  });

  const tags = ['all', 'music', 'read', 'news'];

  return (
    <div className="text-white">
      <h2
        className="font-handwritten text-4xl font-bold mb-4 tracking-tight"
        style={{ fontFamily: PRIMARY_FONT }}
      >
        Latest Releases and News
      </h2>
      <div className="mb-6 flex space-x-2">
        {tags.map(tag => (
          <button
            key={tag}
            onClick={() => setActiveTag(tag)}
            className={`px-3 py-1 rounded-sm flex font-handwritten text-lg items-center transition-all duration-200 ${
              activeTag === tag
                ? 'bg-sky-400 bg-opacity-20 text-sky-300 border border-sky-400 border-opacity-30'
                : 'text-white text-opacity-30 border border-white border-opacity-5 hover:text-opacity-60'
            }`}
          >
            {tag !== 'all' && (() => {
              switch(tag) {
                case 'music': return <Music className="mr-1" size={18} />;
                case 'read': return <Book className="mr-1" size={18} />;
                case 'news': return <Popcorn className="mr-1" size={18} />;
                default: return null;
              }
            })()}
            {tag.charAt(0).toUpperCase() + tag.slice(1)}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {sortedEntries.map(entry => (
          <BlogEntry
            key={entry.id}
            entry={entry}
            isExpanded={expandedEntry === entry.id}
            toggleExpand={() => setExpandedEntry(expandedEntry === entry.id ? null : entry.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default AlbumsContent;
